import React from 'react'
import { useIntl } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'
import Label from 'LuxKit/Label/Label'
import Caption from 'LuxKit/Typography/Caption'
import SolidFireIcon from 'LuxKit/Icons/solid/SolidFireIcon'

interface Props {
  saleOnDepartures?: boolean
}

export default function TourDiscountLabel(props: Props) {
  const { saleOnDepartures = false } = props
  const intl = useIntl()

  const limitedTimeSpecialText = intl.formatMessage(
    {
      id: 'wMhDBtZZNY',
      defaultMessage: 'Limited Time Special',
      description: 'Label indicating a limited-time special discount on a tour',
    },
  )
  const selectDeparturesText = intl.formatMessage(
    {
      id: 'xroag2BjHS',
      defaultMessage: '(select departures)',
      description: 'Parenthetical note indicating the discount applies only to select departure dates',
    },
  )

  return (
    <Label kind="plain" variant="urgency" startIcon={<SolidFireIcon />}>
      <Caption variant="medium" weight="bold">
        {limitedTimeSpecialText}{' '}
        {saleOnDepartures && <BodyText variant="small" as="span" colour="neutral-three">{selectDeparturesText}</BodyText>}
      </Caption>
    </Label>
  )
}
